export abstract class URLServiceInterface {
  public abstract login(returnOnly?: boolean, toUrl?: boolean): string;
  public abstract homepage(returnOnly?: boolean);
  public abstract dashboard(returnOnly?: boolean);
}
